import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import './App.css';

function LanguageSwitcher() {
  const { language, toggleLanguage, t } = useLanguage();
  return (
    <button onClick={toggleLanguage} className="language-switcher">
      {language === 'en' ? (
        <>
          <img src="/social-icons/fr-flag.svg" alt="Français" className="flag-icon" />
          <span>FR</span>
        </>
      ) : (
        <>
          <img src="/social-icons/gb-flag.svg" alt="English" className="flag-icon" />
          <span>EN</span>
        </>
      )}
    </button>
  );
}

function HomePage() {
  const { t } = useLanguage();
  return (
    <div className="main-bg">
      <div className="center-container landing-layout alt-cards">
        <div className="intro-section one-column">
          <img src="/logo512.png" alt={t('introProfileAlt')} className="profile-photo" />
          <div className="intro-text">
            <h1 className="main-title">HICKSSAMA</h1>
            <p className="intro-greeting">{t('introGreeting')}</p>
          </div>
        </div>
        <div className="alt-card-row">
          <div className="alt-card-image">
            <a href="https://payhip.com/Hickssama" target="_blank" rel="noopener noreferrer" className="image-link">
              <div className="image-card">
                <img src="/payhip.png" alt={t('videoQualityPresets')} className="feature-image" />
                <h2>{t('videoQualityPresets')}</h2>
              </div>
            </a>
          </div>
          <div className="alt-card-desc">
            <p className="card-desc">{t('introPresetsDesc')}</p>
          </div>
        </div>
        <div className="alt-card-row alt-card-row-reverse">
          <div className="alt-card-image">
            <a href="https://www.beatstars.com/hickssama" target="_blank" rel="noopener noreferrer" className="image-link">
              <div className="image-card">
                <img src="/beatstars.png" alt={t('prods')} className="feature-image" />
                <h2>{t('prods')}</h2>
              </div>
            </a>
          </div>
          <div className="alt-card-desc">
            <p className="card-desc">{t('introProdsDesc')}</p>
          </div>
        </div>
        <div className="social-follow-section">
          <div className="social-links">
            <a href="https://www.tiktok.com/@hickssama" target="_blank" rel="noopener noreferrer" className="social-link">
              <img src="/social-icons/tiktok.svg" alt="TikTok" className="social-icon" />
            </a>
            <a href="https://www.youtube.com/@hickssama" target="_blank" rel="noopener noreferrer" className="social-link">
              <img src="/social-icons/youtube.svg" alt="YouTube" className="social-icon" />
            </a>
            <a href="https://www.instagram.com/hickssama" target="_blank" rel="noopener noreferrer" className="social-link">
              <img src="/social-icons/instagram.svg" alt="Instagram" className="social-icon" />
            </a>
          </div>
          <Link to="/stay-informed" className="stay-informed-link">{t('stayInformed')}</Link>
          <p className="follow-me-text">{t('followMe')}</p>
        </div>
      </div>
      <footer className="footer-copyright non-fixed">{t('copyright')}</footer>
      <LanguageSwitcher />
    </div>
  );
}

function StayInformed() {
  const { t } = useLanguage();
  const [email, setEmail] = React.useState('');
  const [status, setStatus] = React.useState('');

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('');
    try {
      const res = await fetch(`${API_URL}/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (res.ok) {
        setStatus('Subscribed!');
        setEmail('');
      } else {
        const data = await res.json();
        setStatus(data.error || 'Error');
      }
    } catch {
      setStatus('Network error');
    }
  };

  return (
    <div className="main-bg">
      <div className="center-container">
        <Link to="/" className="back-link">{t('backToHome')}</Link>
        <h1 className="main-title">{t('stayInformed')}</h1>
        <form onSubmit={handleSubmit} className="subscribe-form">
          <label className="email-label">{t('email')}</label>
          <input
            type="email"
            required
            placeholder="example@xyz.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            className="email-input"
            style={{ fontFamily: 'inherit' }}
          />
          <button type="submit" className="send-btn" style={{ fontFamily: 'inherit' }}>{t('send')}</button>
          <div className="status-msg">{status}</div>
        </form>
      </div>
      <footer className="footer-copyright">{t('copyright')}</footer>
      <LanguageSwitcher />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/stay-informed" element={<StayInformed />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;